import { API, graphqlOperation } from 'aws-amplify';
import { GraphQLResult } from '@aws-amplify/api-graphql';
import { handleAuthError } from '../../../utils/authError';
import { getDraftCampaigns, getActiveCampaigns, getAllCampaigns, getArchivedCampaigns } from '../../../graphql/queries';
import { Campaign, campaignsQueryParams } from '../../../types/campaign';

type GetCampaigns = {
    [key: string]: {
        items: Campaign[];
    };
};

export const getDraftCampaignsData = async ({filterInput, markets}: campaignsQueryParams) => {
    try {
        const { data } = (await API.graphql(
            graphqlOperation(getDraftCampaigns, {
                configArrSize: 0,
                campaignId: filterInput,
                campaignName: filterInput,
                markets,
            })
        )) as GraphQLResult<GetCampaigns>;

        return data.getDraftCampaigns.items;
    } catch (error) {
        if (!handleAuthError(error)) {
            console.warn(error);
        }
    }
};

export const getActiveCampaignsData = async ({filterInput, markets}: campaignsQueryParams) => {
    try {
        const { data } = (await API.graphql(
            graphqlOperation(getActiveCampaigns, {
                configArrSize: 1,
                campaignId: filterInput,
                campaignName: filterInput,
                markets,
            })
        )) as GraphQLResult<GetCampaigns>;

        return data.getActiveCampaigns.items;
    } catch (error) {
    if (!handleAuthError(error)) {
        console.warn(error);
    }
}
};

export const getAllCampaignsData = async ({filterInput, markets}: campaignsQueryParams) => {
    try {
        const { data } = (await API.graphql(
            graphqlOperation(getAllCampaigns, {
                campaignId: filterInput,
                campaignName: filterInput,
                markets,
            })
        )) as GraphQLResult<GetCampaigns>;

        return data.getAllCampaigns.items;
    } catch (error) {
    if (!handleAuthError(error)) {
        console.warn(error);
    }
}
};

export const getArchivedCampaignsData = async ({filterInput, markets}: campaignsQueryParams) => {
    try {
        const { data } = (await API.graphql(
            graphqlOperation(getArchivedCampaigns, {
                campaignId: filterInput,
                campaignName: filterInput,
                markets,
            })
        )) as GraphQLResult<GetCampaigns>;

        return data.getArchivedCampaigns.items;
    } catch (error) {
    if (!handleAuthError(error)) {
        console.warn(error);
    }
}
};
